import React, { useRef } from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import _size from "lodash/size"
import _filter from "lodash/filter"
import _some from "lodash/some"

import Select from "react-select"
import CustomOption from "./CustomOption"
import CustomGroup from "./CustomMenuList"

import styles from "./styles.css"

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    borderRadius: "12px",
    border: "1px solid #3C4646",
    cursor: "pointer",
    padding: "2px",
    ":hover": {
      border: "1px solid #3C4646"
    }
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#0a645a",
    ":hover": {
      ...styles.hover,
      color: "#0a645a"
    }
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: "#0a645a",
    ":hover": {
      ...styles.hover,
      color: "#0a645a"
    }
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "rgba(10, 100, 90, 0.2)",
    borderRadius: "12px",
    padding: "2px"
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "#3C4646"
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "#3C4646",
    ":hover": {
      color: "#3C4646",
      cursor: "pointer"
    }
  })
}

const SelectMult = ({
  id,
  defaultValue = [],
  name = "default",
  options,
  onChange,
  classNames = "",
  placeholder = "Selecione as opções",
  labelForAllOptions = "Selecionar todos",
  maxValueAllow = 9999,
  isDisabled = false,
  ...props
}) => {
  const { value } = props
  const qtdValues = _size(value)
  const valueRef = useRef(value)
  valueRef.current = value

  const maxSizeExceed = qtdValues > maxValueAllow
  const placeholderDefaultOrMaxSize = maxSizeExceed
    ? `${qtdValues} opções selecionadas...`
    : placeholder

  const selectAllOption = {
    value: "SELECT_ALL",
    label: labelForAllOptions
  }

  const getValues = () => [selectAllOption, ...options]

  const isSelectAllSelected = () => valueRef.current.length === options.length

  const isOptionSelected = (option) =>
    _some(valueRef.current, ({ value }) => value === option.value) ||
    isSelectAllSelected()

  const onChangeHandler = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta

    const selectedAll =
      action === "select-option" && option.value === selectAllOption.value

    const removeAll =
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)

    const removeOptionWithAllSelected =
      action === "deselect-option" && isSelectAllSelected()

    if (selectedAll) {
      onChange(options, actionMeta)
      return
    }

    if (removeAll) {
      onChange([], actionMeta)
      return
    }

    if (removeOptionWithAllSelected) {
      const optionsFiltered = _filter(
        options,
        ({ value }) => value !== option.value
      )

      onChange(optionsFiltered, actionMeta)
      return
    }

    onChange(newValue, actionMeta)
  }

  const selectClassNames = classnames(
    {
      [styles.disabled]: isDisabled
    },
    classNames
  )

  return (
    <Select
      id={id}
      isDisabled={isDisabled}
      isOptionSelected={isOptionSelected}
      defaultValue={defaultValue}
      isMulti
      name={name}
      options={getValues()}
      onChange={onChangeHandler}
      classNamePrefix="select"
      className={selectClassNames}
      styles={colourStyles}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      placeholder={placeholderDefaultOrMaxSize}
      maxMenuHeight={100}
      minMenuHeight={100}
      controlShouldRenderValue={!maxSizeExceed}
      components={{
        MenuList: CustomGroup,
        Option: CustomOption
      }}
      {...props}
    />
  )
}

SelectMult.propTypes = {
  id: PropTypes.string,
  defaultValue: PropTypes.array,
  name: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  classNames: PropTypes.string,
  placeholder: PropTypes.string,
  maxValueAllow: PropTypes.number,
  value: PropTypes.array,
  labelForAllOptions: PropTypes.string,
  isDisabled: PropTypes.bool
}

export default SelectMult



// WEBPACK FOOTER //
// ./src/shared/components/SelectMult/index.js